import { createContext, useState } from 'react';

import * as T from 'prop-types';
import { WHO_AM_I_URL } from 'utils/api-urls';

import useUserInfo from '../hooks/use-user-info';

const AuthContext = createContext();

function AuthProvider({ children }) {
  const [isGtmLoaded, setIsGtmLoaded] = useState(false);

  const isTermsPage = window?.location?.pathname?.match('terms-of-service');
  const whoAmIUrl = isTermsPage ? `${WHO_AM_I_URL}?origin=terms-of-service` : WHO_AM_I_URL;

  const userInfo = useUserInfo(whoAmIUrl);
  return (
    <AuthContext.Provider value={{ userInfo, setIsGtmLoaded, isGtmLoaded }}>
      {children}
    </AuthContext.Provider>
  );
}

AuthProvider.propTypes = {
  children: T.node.isRequired,
};

export { AuthProvider, AuthContext };
